var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((_vm.config.IsOfficial&&_vm.mallInfo.MallId==762)||(!_vm.config.IsOfficial&&_vm.mallInfo.MallId==166))?_c('newConfig'):_c('agentConfig')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }